import { render, staticRenderFns } from "./automatics.vue?vue&type=template&id=2a4a7593&scoped=true"
import script from "./automatics.vue?vue&type=script&lang=js"
export * from "./automatics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a7593",
  null
  
)

export default component.exports